import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';
import { languageCrudConfig, type Language } from '@/config/objects/languages';

export function LanguageFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Languages', href: '/languages' },
    { label: isEdit ? 'Edit Language' : 'Create Language', current: true },
  ];

  const handleSuccess = (item: Language) => {
    navigate(`/languages/${item.id}`);
  };

  return (
    <PageContainer>
      <CrudFormView
        config={languageCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
